import { PropsWithChildren, ReactNode, useEffect, useState } from "react";
import Logo from "./Logo";
import { useGuard } from "../Guard";
import { Col, Layout, Typography } from "antd";
import Loader from "../controls/Loader";

export interface ContentLoadingProps {
  readonly loading?: boolean;
  readonly title?: string;
  readonly logo?: boolean;
  readonly icon?: ReactNode;
  readonly message?: string;
  readonly tryLogout?: boolean;
  readonly nointernet?: boolean;
  readonly keepContent?: true;
}

function ContentLoading(props: PropsWithChildren<ContentLoadingProps>) {
  const guard = useGuard();
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    if (props.loading) {
      setAnimate(true);
    }
  }, [props.loading]);

  function onLogout(): void {
    guard.signOut();
  }

  return (
    <>
      {(props.keepContent || !props.loading) && (
        <Col className="animate__animated animate__fadeIn flex flex-auto flex-col overflow-hidden">
          {props.children}
        </Col>
      )}
      <Layout
        className={`animate__animated absolute bottom-0 left-0 right-0 top-0 z-10 overflow-hidden ${animate ? (props.loading ? "animate__fadeInUp" : "animate__fadeOutDown") : "hidden"}`}
      >
        <Col className="flex flex-auto flex-col items-center justify-center overflow-hidden">
          <Col className="absolute bottom-10 left-0 right-0 top-0 z-10 flex flex-auto flex-col items-center justify-center overflow-hidden">
            {props.logo && !props.icon && <Logo className="mb-8 w-24" />}
            {!props.logo && props.icon && (
              <Col className="mb-8">{props.icon}</Col>
            )}
            {props.title && (
              <Typography.Text className="mb-4">{props.title}</Typography.Text>
            )}
            {props.message && (
              <Typography.Text>{props.message}</Typography.Text>
            )}
            <Loader size="large" />
          </Col>
          {props.tryLogout && !props.nointernet && (
            <Typography.Text className="absolute bottom-0 h-10">
              Something went wrong,&nbsp;
              <Typography.Link onClick={onLogout}>
                try login again
              </Typography.Link>
            </Typography.Text>
          )}
        </Col>
      </Layout>
      {props.nointernet && (
        <Typography.Text className="absolute bottom-0 left-0 right-0 z-50 m-0 p-0 text-center">
          Internet connection problems
        </Typography.Text>
      )}
    </>
  );
}

export default ContentLoading;
